import React from "react";
import { Link, NavLink } from "react-router-dom";
import { FlaskConical, GitCompare, TrendingUp, ScanBarcode, Heart, BookOpen } from "lucide-react";
import MobileMenu from "./MobileMenu";

export const Header = () => {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-xl bg-[color:var(--bg)]/70 border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Link to="/" data-testid="logo-home" className="flex items-center gap-2 group">
          <div className="relative">
            <div className="h-8 w-8 rounded-lg bg-[color:var(--lime)] flex items-center justify-center">
              <FlaskConical className="h-4 w-4 text-[#07130a]" strokeWidth={2.5} />
            </div>
            <div className="absolute -inset-1 bg-[color:var(--lime)]/20 blur-lg opacity-0 group-hover:opacity-100 transition-opacity -z-10" />
          </div>
          <div className="font-display font-bold text-lg tracking-tight">
            WhatIs<span className="text-[color:var(--lime)]">Inside</span>
          </div>
        </Link>
        <div className="flex items-center gap-2 md:hidden">
          <NavLink
            to="/scan"
            data-testid="nav-scan-mobile"
            aria-label="Scan a barcode"
            className="lime-btn rounded-full px-4 py-2 text-sm font-semibold inline-flex items-center gap-2"
          >
            <ScanBarcode className="h-4 w-4" strokeWidth={2.5} /> Scan
          </NavLink>
          <MobileMenu />
        </div>
        <nav className="hidden md:flex items-center gap-1 text-sm font-mono uppercase tracking-wider">
          <NavLink
            to="/scan"
            data-testid="nav-scan"
            className={({ isActive }) =>
              `px-3 py-2 rounded-md flex items-center gap-2 transition-colors ${
                isActive ? "text-[color:var(--lime)]" : "text-[color:var(--text-2)] hover:text-[color:var(--text)]"
              }`
            }
          >
            <ScanBarcode className="h-3.5 w-3.5" /> Scan
          </NavLink>
          <NavLink
            to="/ingredients"
            data-testid="nav-ingredients"
            className={({ isActive }) =>
              `px-3 py-2 rounded-md flex items-center gap-2 transition-colors ${
                isActive ? "text-[color:var(--lime)]" : "text-[color:var(--text-2)] hover:text-[color:var(--text)]"
              }`
            }
          >
            <BookOpen className="h-3.5 w-3.5" /> Ingredients
          </NavLink>
          <NavLink
            to="/compare"
            data-testid="nav-compare"
            className={({ isActive }) =>
              `px-3 py-2 rounded-md flex items-center gap-2 transition-colors ${
                isActive ? "text-[color:var(--lime)]" : "text-[color:var(--text-2)] hover:text-[color:var(--text)]"
              }`
            }
          >
            <GitCompare className="h-3.5 w-3.5" /> Compare
          </NavLink>
          <NavLink
            to="/favorites"
            data-testid="nav-favorites"
            className={({ isActive }) =>
              `px-3 py-2 rounded-md flex items-center gap-2 transition-colors ${
                isActive ? "text-[color:var(--lime)]" : "text-[color:var(--text-2)] hover:text-[color:var(--text)]"
              }`
            }
          >
            <Heart className="h-3.5 w-3.5" /> Saved
          </NavLink>
          <NavLink
            to="/trending"
            data-testid="nav-trending"
            className={({ isActive }) =>
              `px-3 py-2 rounded-md flex items-center gap-2 transition-colors ${
                isActive ? "text-[color:var(--lime)]" : "text-[color:var(--text-2)] hover:text-[color:var(--text)]"
              }`
            }
          >
            <TrendingUp className="h-3.5 w-3.5" /> Trending
          </NavLink>
          <NavLink
            to="/about"
            data-testid="nav-about"
            className={({ isActive }) =>
              `px-3 py-2 rounded-md transition-colors ${
                isActive ? "text-[color:var(--lime)]" : "text-[color:var(--text-2)] hover:text-[color:var(--text)]"
              }`
            }
          >
            About
          </NavLink>
        </nav>
      </div>
    </header>
  );
};

export default Header;
